import axios from "axios";
import { useQuery } from "react-query";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { END_POINT } from "config/environment";
import { TSubscriptionRule } from "../types";

const getRule = async (props: {
  token: string;
  id: string;
}): Promise<TSubscriptionRule> => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/subscription-rules/view/${props.id}`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const res = await axios.get<TSubscriptionRule>(url, config);
  return res.data;
};

export const useGetSubscriptionRule = (id: string | undefined, enabled: boolean) => {
  const { token } = useGetUserInfo();
  return useQuery(
    ["admin-subscription-rule", id],
    () => getRule({ token, id: id! }),
    {
      enabled: Boolean(enabled && id && token),
    }
  );
};
